export default __webpack_public_path__ + "media/images/sms-6edc035f.svg";